import { useEffect, useState } from "react";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { useAppLinkContext } from "../modules/useAppLink";

import VFlex from "../layouts/VFlex";

import { apiV2 } from "../common/api";

export enum TopBannerLocation {
  reservation = "reservation",
  serviceNote = "service_note",
  questionnaireResult = "questionnaire_result",
}

interface Banner {
  code: string;
  displayType: string;
  targetCode: string;
  title: string;
  description: string;
  attachment: {
    id: number;
    key: string;
    url: string;
    path: string;
    lastModified: number;
  };
  clickLink: string;
  sortOrder: number;
}

SwiperCore.use([Autoplay]);

export default function TopBanner({
  location,
}: {
  location?: TopBannerLocation;
}) {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiV2.get("/v1.0/events?type=BANNER");

        setBanners(data.sort(() => Math.random() - 0.5));
      } catch (e) {}
    })();
  }, []);

  const { openAppLink } = useAppLinkContext();

  return (
    <VFlex
      style={{
        maxWidth: "480px",
        width: "100%",
      }}
    >
      <Swiper
        style={{
          width: "100%",
          borderRadius: "4px",
        }}
        slidesPerView={1}
        threshold={10}
        centeredSlides={true}
        loop={true}
        loopPreventsSlide={false}
        autoplay={{
          delay: 3000,
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.code}>
            <img
              src={banner.attachment.url}
              alt={banner.title}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
              onClick={() => {
                if (!banner.targetCode) return;

                if (window.FlutterChannel) {
                  window.FlutterChannel.postMessage(
                    JSON.stringify({
                      action: "campaignClick",
                      payload: {
                        targetCode: banner.targetCode,
                        title: banner.title,
                      },
                    }),
                  );
                } else {
                  openAppLink(`top_banner_${location}`);
                }
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "6px",
          marginTop: "12px",
        }}
      >
        {banners.map((_, i) => (
          <div
            key={i}
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: i === activeIndex ? "#222" : "#D9D9D9",
              transition: "background-color 0.2s",
            }}
          />
        ))}
      </div>
    </VFlex>
  );
}
